/**
 * 环境配置管理
 * @author Jeremy.caoyu
 * @created 2019-05-14
 */

import { isIP } from "./isIp";

// 环境判断
const isDevelopment = () => {
  const host = window.location.host;
  const hostname = window.location.hostname;
  return (
    host.indexOf("localhost") > -1 ||
    isIP(hostname) ||
    host.indexOf("mydev.myyixue.com") > -1 ||
    host.indexOf("fe.dev.myyixue.com") > -1
  );
};

const isDevEnvironment = () => {
  const host = window.location.host;
  return host.indexOf("dev.myyixue.com") > -1;
};

const isTestEnvironment = () => {
  const host = window.location.host;
  return host.indexOf("test-agent.myyixue.com") > -1;
};

const isPreEnvironment = () => {
  return window.location.host === "agent-pre.songshuai.com";
};

// 国外正式环境
const isForeignEnvironment = () => {
  return window.location.host === "agent.squirrelai.com";
};

// API 路径配置
const API_PATHS = {
  agentManage: "/agentmanage/api/",
  agentManageApi: "/agentmanageapi/api/",
  agentCrm: "/agentcrm/api/",
  agentCrmApi: "/agentcrmapi/api/",
  agentManageBackManage: "/agentmanagebackmanage/api/",
  newAgentManage: "/agentmanagebackmanage/",
};

// 环境配置
const ENV_CONFIG = {
  dev: {
    baseUrl: "http://agent-api.zc.dev.myyixue.com",
    //baseUrl: "https://agent-api-test.classba.cn",
    env: "dev",
    urls: {
      phpUrl: "http://test-schooladmin.myyixue.com/api",
      reportUrl: "http://school-report.myyixue.com/",
      erpUrl: "http://test-erp.myyixue.com/ForeignAPI/",
      accountCenter: "//sso.fe.dev.myyixue.com",
      dlUrl: "http://dl.fe.dev.myyixue.com/",
      evaluationUrl: "http://paddl.fe.dev.myyixue.com/",
      appUrl: "http://share-test.xdatam.cn/",
    }
  },
  test: {
    baseUrl: "https://agent-api-test.classba.cn",
    env: "test",
    urls: {
      phpUrl: "//test-schooladmin.myyixue.com/api",
      reportUrl: "https://school-report.myyixue.com/",
      erpUrl: "https://test-erp.myyixue.com/ForeignAPI/",
      accountCenter: "//sso-test.songshuai.com",
      dlUrl: "https://dl-test.classba.cn/",
      evaluationUrl: "https://paddl.test.classba.cn/",
      appUrl: "https://share-test.xdatam.cn/",
    }
  },
  pre: {
    baseUrl: "https://agent-api-pre.classba.cn",
    env: "pre",
    urls: {
      phpUrl: "//schooladmin.songshuai.com/api",
      reportUrl: "https://school-report.songshuai.com/",
      erpUrl: "https://erp.songshuai.com/ForeignAPI/",
      accountCenter: "//sso-pre.songshuai.com",
      dlUrl: "https://dl-pre.classba.cn/",
      evaluationUrl: "https://exp4pad-pre.classba.cn/",
      appUrl: "https://share-pre.xdatam.cn/",
    }
  },
  prod: {
    baseUrl: "https://agent-api.classba.cn",
    env: "pro",
    urls: {
      phpUrl: "//schooladmin.songshuai.com/api",
      reportUrl: "https://school-report.songshuai.com/",
      erpUrl: "https://erp.songshuai.com/ForeignAPI/",
      accountCenter: "//sso.songshuai.com",
      dlUrl: "https://dl.classba.cn/",
      evaluationUrl: "https://exp4pad.classba.cn/",
      appUrl: "https://share.xdatam.cn/",
    }
  },
  foreign: {
    baseUrl: "https://agent-api.ssai1.com",
    env: "foreign",
    urls: {
      phpUrl: "//schooladmin.ssai1.com/api",
      reportUrl: "https://school-report.ssai1.com/",
      erpUrl: "https://erp.ssai1.com/ForeignAPI/",
      accountCenter: "//sso.squirrelai.com/global",
      dlUrl: "https://dl.ssai1.com/",
      evaluationUrl: "https://exp4pad.ssai1.com/",
      appUrl: "https://share.ssai1.com/",
    }
  },
};

// 获取当前环境配置
const getCurrentConfig = () => {
  if (isDevelopment()) {
    return ENV_CONFIG.dev;
    // return ENV_CONFIG.test;
    // return ENV_CONFIG.pre;
  }
  if (isPreEnvironment()) {
    return ENV_CONFIG.pre;
  }
  if (isDevEnvironment()) {
    return ENV_CONFIG.dev;
  }
  if (isTestEnvironment()) {
    return ENV_CONFIG.test;
  }
  // 国外正式环境
  if (isForeignEnvironment()) {
    return ENV_CONFIG.foreign;
  }
  return ENV_CONFIG.prod;
};

// 生成API URL
const generateApiUrl = (baseUrl, path) => `${baseUrl}${path}`;

// 获取基础URLs
export const getBasicUrls = () => {
  const config = getCurrentConfig();
  const { baseUrl, env, urls } = config;
  const isDev = isDevEnvironment();

  // 开发环境特殊处理
  if (isDevelopment() && localStorage.getItem("IP")) {
    return "//" + localStorage.getItem("IP") + "/api/";
  }

  // 根据环境选择API路径
  const getApiPath = (isDevEnv) => {
    if (isDevEnv) {
      return {
        schoolArea: API_PATHS.agentManageBackManage,
        crm: API_PATHS.agentCrm,
        schoolCrm: API_PATHS.agentManageBackManage,
        crmApi: API_PATHS.agentCrmApi,
        schoolmApi: API_PATHS.agentManageBackManage,
        treeApi: API_PATHS.agentManageApi,
        schoolm: API_PATHS.agentManageBackManage,
        newAgentManage: API_PATHS.newAgentManage,
      };
    }
    return {
      schoolArea: API_PATHS.agentManageApi,
      crm: API_PATHS.agentCrm,
      schoolCrm: API_PATHS.agentManageBackManage,
      crmApi: API_PATHS.agentCrmApi,
      schoolmApi: API_PATHS.agentManageApi,
      treeApi: API_PATHS.agentManageApi,
      schoolm: API_PATHS.agentManageBackManage,
      newAgentManage: API_PATHS.newAgentManage,
    };
  };

  const apiPaths = getApiPath(isDev);

  return {
    schoolAreaUrl: generateApiUrl(baseUrl, apiPaths.schoolArea),
    crm: generateApiUrl(baseUrl, apiPaths.crm),
    schoolCrm: generateApiUrl(baseUrl, apiPaths.schoolCrm),
    crmApi: generateApiUrl(baseUrl, apiPaths.crmApi),
    phpUrl: urls.phpUrl,
    reportUrl: urls.reportUrl,
    schoolmApi: generateApiUrl(baseUrl, apiPaths.schoolmApi),
    treeApi: generateApiUrl(baseUrl, apiPaths.treeApi),
    schoolm: generateApiUrl(baseUrl, apiPaths.schoolm),
    newAgentManage: generateApiUrl(baseUrl, apiPaths.newAgentManage),
    erpUrl: urls.erpUrl,
    daraBaseUrl: env === "dev"
      ? `${window.location.protocol}//${window.location.hostname}:3001`
      : "//schooldb.songshuai.com",
    accountCenter: urls.accountCenter,
    dlUrl: urls.dlUrl,
    evaluationUrl: urls.evaluationUrl,
    appUrl: urls.appUrl,
    baseUrl,
    env,
  };
};

// 获取基础URL
export const getBaseUrl = () => {
  if (isDevelopment() && localStorage.getItem("IP")) {
    return "//" + localStorage.getItem("IP") + "/api/";
  }

  const config = getCurrentConfig();
  return generateApiUrl(config.baseUrl, API_PATHS.agentCrm);
};

// 获取PHP URL
export const getPhpUrl = () => {
  return "https://schooladmin-pre.songshuai.com/api";
};

// 获取报表URL
export const reportURL = () => {
  if (isDevelopment() && localStorage.getItem("IP")) {
    return "//" + localStorage.getItem("IP") + "/api";
  }

  const config = getCurrentConfig();
  return config.urls.reportUrl;
};

// 获取WebSocket URL
export const getScoketUrl = () => {
  if (isDevelopment() && localStorage.getItem("IP")) {
    return "//" + localStorage.getItem("IP") + "/api/";
  }

  if (isPreEnvironment()) {
    return "//agent-ws-pre.songshuai.com";
  }

  const config = getCurrentConfig();
  return config.env === "dev" ? "//test-agent-ws.myyixue.com" : "//agent-ws.songshuai.com";
};
